// State Name
export const EXPRESS_TRACKING = 'EXPRESS_TRACKING';
export const EXPRESS_TRACKING_ADD_INSTRUCTION =
  'EXPRESS_TRACKING_ADD_INSTRUCTION';
export const EXPRESS_ACQUISITION_BANNER = 'EXPRESS_ACQUISITION_BANNER';
export const EXPRESS_TRACKING_PAYMENT_FOOTER =
  'EXPRESS_TRACKING_PAYMENT_FOOTER';
export const TRACKING_PAGE_TYPE = {
  GUEST_ORDER_SEARCH: 'GUEST ORDER SEARCH',
  NEW_TRACKING_LINK: 'NEW TRACKING LINK',
};

export const ALL_FACETS_PARAMS = {
  TRACKING_SOURCE: 'TRACKING_SOURCE',
  IS_TRACKING_LINK_EXPIRED: 'IS_TRACKING_LINK_EXPIRED',
  ADD_INSTRUCTION_POSITION: 'ADD_INSTRUCTION_POSITION',
  ORDER_ID_DISPLAYED: 'ORDER_ID_DISPLAYED',
  IS_IN_APP: 'IS_IN_APP',
  TRACKING_PAGE_TYPE: 'TRACKING_PAGE_TYPE',
  POD_AMOUNT: 'POD_AMOUNT',
};

export const TRACKING_SOURCE = {
  GE_WEB_BOOKING: 'GE WEB BOOKING PAGE',
  GE_HOME_PAGE: 'GE HOME PAGE',
  GRAB_COM_LANDING_PAGE: 'GRAB.COM LANDING PAGE',
  GRAB_INBOX: 'GRAB INBOX',
  GUEST_ORDER_SEARCH: 'GUEST ORDER SEARCH',
  TRACKING_LINK: 'TRACKING LINK',
};

export const URL_PARAMS_MAP_TRACKING_SOURCE = {
  gehomepage: TRACKING_SOURCE.GE_HOME_PAGE,
  grabcom: TRACKING_SOURCE.GRAB_COM_LANDING_PAGE,
  webbooking: TRACKING_SOURCE.GE_WEB_BOOKING,
};

export const ADD_INSTRUCTION_POSITION = {
  MAP: 'MAP',
  POI_SIDE_BAR: 'POI SIDE BAR',
};

const EXPRESS_TRACKING_EVENT = {
  DEFAULT: 'DEFAULT',
  BACK: 'BACK',
  ADD_INSTRUCTION: 'ADD_INSTRUCTION',
  CONFIRM_TRACKING: 'CONFIRM_TRACKING',
  COPY: 'COPY',
  VIEW_PROOF: 'VIEW_PROOF',
  CALL: 'CALL',
  CHAT: 'CHAT',
  GET_SUPPORT: 'GET_SUPPORT',
  PAY: 'PAY',
};

const EXPRESS_TRACKING_ADD_INSTRUCTION_EVENT = {
  DEFAULT: 'DEFAULT',
  CLOSE: 'CLOSE',
  SEND: 'SEND',
};

const EXPRESS_ACQUISITION_BANNER_EVENT = {
  DEFAULT: 'DEFAULT',
  CLICK: 'CLICK',
  POD_REMINDER_VIEW: 'POD_REMINDER_VIEW',
  POD_DOWNLOAD_CLICK: 'POD_DOWNLOAD_CLICK',
};

const Instrumentation = {
  [EXPRESS_TRACKING]: EXPRESS_TRACKING_EVENT,
  [EXPRESS_TRACKING_ADD_INSTRUCTION]: EXPRESS_TRACKING_ADD_INSTRUCTION_EVENT,
  [EXPRESS_ACQUISITION_BANNER]: EXPRESS_ACQUISITION_BANNER_EVENT,
};

export default Instrumentation;
